<template>
	<div>
		<b-breadcrumb>Voices</b-breadcrumb>
		<b-alert :show="!!error" variant="danger">{{error&&(error.error||error.toString())}}</b-alert>
		<b-input v-model="q" placeholder="Search..." @input="loadVoices()" class="mb-2"></b-input>
		<b-table small striped hover :items="voices" :busy="loading>0" :fields="['voice','provider','selector',{ key: 'usage_count', label: 'Usage' },'ban_count','aliases', 'flags']">
			<template #cell(voice)="data">
				{{data.item.description||data.item.name}}<br />
				<small>{{data.item.language}} {{data.item.age}} {{data.item.sex}}</small>
			</template>
			<template #cell(provider)="data">
				{{data.item.provider}}<br />
				<small>{{data.item.type}}</small>
			</template>
			<template #cell(selector)="data">
				<code v-if="data.item.selector">!voice {{data.item.selector}}</code><br />
				<code v-if="data.item.unique_id">!voice {{data.item.unique_id}}</code>
			</template>
			<template #cell(usage_count)="data">
				{{data.item.chatter_count}} / {{data.item.chatter_channel_count}}
			</template>
			<template #cell(flags)="data">
				<b-form-checkbox switch v-model="data.item.flags.default" @change="toggleVoiceFlag(data.item)" :disabled="data.item.settingFlags" :state="data.item.settingFlagsState">Default</b-form-checkbox>
				<b-form-checkbox switch v-model="data.item.flags.regular" @change="toggleVoiceFlag(data.item)" :disabled="data.item.settingFlags" :state="data.item.settingFlagsState">Regular</b-form-checkbox>
				<b-form-checkbox switch v-model="data.item.flags.pro" @change="toggleVoiceFlag(data.item)" :disabled="data.item.settingFlags" :state="data.item.settingFlagsState">Pro</b-form-checkbox>
			</template>
		</b-table>
		<pager :per-page="perPage" :skip="skip" :total="total" @change="setPage"></pager>
	</div>
</template>

<script>
import Pager from '@/components/Pager.vue';

export default {
	name: 'Voices',
	components: {
		Pager,
	},
	data() { return {
		voices: [],
		error: null,
		loading: 0,
		total: 0,
		skip: 0,
		perPage: 10,
		q: undefined,
	}},
	created() {
		this.skip = parseInt(this.$route.query.skip||0)||0;
		this.perPage = parseInt(this.$route.query.perPage||10)||10;
		this.loadVoices();
	},
	watch: {
		'$route': 'loadVoices',
		'q': 'loadVoices',
	},
	methods: {
		setPage($event) {
			this.skip = $event.skip;
			this.perPage = $event.perPage;
			this.$router.push({ query: { ...this.$route.query, skip: $event.skip || undefined, perPage: $event.perPage == 10 ? undefined : $event.perPage } });
		},
		loadVoices() {
			this.loading++;
			this.error = null;
			this.$api.get('voices', { q: this.q||'', limit: this.perPage, skip: this.skip }).then(voices => {
				this.voices = voices.results;
				this.total = voices.total;
			}).catch(err => this.error = err).finally(() => this.loading--);
		},
		async toggleVoiceFlag(voice) {
			this.loading++;
			this.error = null;
			try {
				await this.$api.post(`voices/${encodeURIComponent(voice.provider)}/${encodeURIComponent(voice.id)}`, { flags: Object.entries(voice.flags).filter(a => !!a[1]).map(a => a[0]), });
				this.$bvToast.toast('Voice flags changed', { title: 'Success', variant: 'success', solid: true });
			} catch(e) {
				this.error = e;
			} finally {
				this.loading--;
			}
		},
	},
};
</script>
